var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 400,
    viewBox: "0 0 362 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_154700)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.728 0.0777568C250.177 -2.10365 297.508 43.4734 323.247 88.3736C345.251 126.76 313.465 173.276 320.79 216.498C326.335 249.221 358.96 272.782 360.112 305.915C361.61 348.987 360.112 351.457 320.79 385.682C286.545 411.544 242.562 397.289 196.728 385.682C166.958 378.144 135.675 384.709 107.673 372.441C74.1874 357.769 40.3087 340.132 22.4246 309.312C2.47563 274.933 -5.05318 233.578 4.96234 195.437C15.3619 155.834 48.6015 128.148 77.8114 98.3905C114.577 60.9357 143.09 2.26688 196.728 0.0777568Z",
    fill: "#081725"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5488,
    y: 43,
    width: 218,
    height: 56,
    rx: 12,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.549,
    cy: 71,
    r: 16,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.27,
    y: 58.0566,
    width: 45.7767,
    height: 8.58313,
    rx: 4.29157,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.27,
    y: 75.3608,
    width: 98.4513,
    height: 8.58313,
    rx: 4.29157,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5488,
    y: 104,
    width: 218,
    height: 248.185,
    rx: 10.5611,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 122.482,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 114.561,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 124.462,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 148.885,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 140.964,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 150.865,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 175.287,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 167.366,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 177.267,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 201.69,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 193.769,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 203.67,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 228.092,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 220.171,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 230.072,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 254.495,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 246.574,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 256.475,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 280.898,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 272.977,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 282.878,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 307.3,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 299.379,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 309.28,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0311,
    cy: 333.703,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 325.782,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 335.683,
    width: 177.076,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_154700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360.902,
    height: 400,
    fill: "white",
    transform: "translate(0.548828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBack);
export default __webpack_public_path__ + "static/media/dashboard-back.494702b9f7b0fad0e29b05271ae53bc9.svg";
export { ForwardRef as ReactComponent };